
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"8.853","cy":"5.283","r":"4.283","stroke":"#fff","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M1 19.052H0a1 1 0 001 1v-1zm.09 0l.968-.248a1 1 0 00-.969-.752v1zm-.073-.401l.996.084a1.001 1.001 0 00-.002-.192l-.994.108zM1 18.338v-1a1 1 0 00-1 1h1zm.054 0v1a1 1 0 00.988-.848l-.988-.152zm15.892 0l-.989.152a1 1 0 00.989.848v-1zm.054 0h1a1 1 0 00-1-1v1zm-.017.313l-.994-.108a.997.997 0 00-.002.192l.996-.084zm.017.4v1a1 1 0 001-1h-1zm-.09 0v-1a1 1 0 00-.968.753l.969.248zm-15.91 1h.09v-2H1v2zm-.98-1.485c-.013.16-.02.322-.02.486h2c0-.108.005-.213.013-.317L.02 18.566zm1.991-.023A1.904 1.904 0 012 18.338H0c0 .141.008.282.023.42l1.988-.215zM1 19.338h.054v-2H1v2zm8-7.03c-4.305 0-8.359 2.141-8.934 5.877l1.976.305c.352-2.281 3.06-4.182 6.958-4.182v-2zm8.934 5.877C17.36 14.45 13.305 12.308 9 12.308v2c3.898 0 6.606 1.9 6.957 4.182l1.977-.305zm-.988 1.153H17v-2h-.054v2zm-.946-1c0 .07-.004.138-.011.205l1.988.215c.015-.138.023-.279.023-.42h-2zm2 .713c0-.163-.007-.325-.02-.485l-1.993.17c.008.103.013.208.013.316h2zm-1.09 1H17v-2h-.09v2zm-.968-1.247a1.873 1.873 0 01-1.814 1.405v2a3.873 3.873 0 003.751-2.91l-1.937-.495zm-1.814 1.405H3.872v2h10.256v-2zm-10.256 0a1.873 1.873 0 01-1.814-1.405l-1.937.495a3.873 3.873 0 003.75 2.91v-2z","fill":"#fff"}})])
          )
        }
      }
    